// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__2DCre","approved":"Status_approved__1_BlB","rejected":"Status_rejected__YrXaW","expired":"Status_expired__3AwOU","label":"Status_label__3s8G9"};